import { Component, inject, Input, OnInit } from "@angular/core";
import { map, startWith, take, takeUntil, tap } from "rxjs/operators";
import {
  PerformanceReviewService,
  TASK_TEMPLATE_ENUM,
  TASK_TEMPLATE_STATUS,
  TEMPLATE_TYPE_DISPLAY,
} from "src/app/services/performance-review.service";
import { CustomisedSingleSelectComponent } from "../../../../shared/components/customised-single-select/customised-single-select.component";
import { toSignal } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup } from "@angular/forms";
import { combineLatest } from "rxjs";
import { WithDestroy } from "src/app/shared/utils/mixins/withDestroy";

@Component({
  selector: "app-activity-selector",
  imports: [CustomisedSingleSelectComponent],
  templateUrl: "./activity-selector.component.html",
  styleUrl: "./activity-selector.component.scss",
})
export class ActivitySelectorComponent extends WithDestroy() implements OnInit {
  @Input() submitted;
  @Input() controls;
  @Input() initValues?;
  activityOptions = [
    { label: TEMPLATE_TYPE_DISPLAY.get(TASK_TEMPLATE_ENUM.assessment), value: TASK_TEMPLATE_ENUM.assessment},
    { label: TEMPLATE_TYPE_DISPLAY.get(TASK_TEMPLATE_ENUM.meeting), value: TASK_TEMPLATE_ENUM.meeting },
  ];
  form = new FormGroup({
    activityType: new FormControl(TASK_TEMPLATE_ENUM.assessment)
  });
  private performanceReviewService = inject(PerformanceReviewService);

  // options = toSignal(
  //   this.performanceReviewService.fetchCacheTaskTemplatesFiltered().pipe(
  //     map((activites) =>
  //       activites.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.assessment)
  //     ),
  //     map((activites) =>
  //       activites.map((a) => ({
  //         label: a?.title,
  //         value: a?.templateID,
  //       }))
  //     ),
  //   ),  { initialValue: [] });

  options;

  constructor(){
    super();
  }

  ngOnInit(): void {
    combineLatest([
      this.performanceReviewService.fetchCacheTaskTemplatesFiltered(),
      this.form.get('activityType').valueChanges.pipe(startWith(this.form.get('activityType')?.value)),
    ]).pipe(
      takeUntil(this.destroy$)
        // map((activites) =>
        //   activites.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.assessment)
        // ),
      )
      .subscribe(([res, activityType]) => {
        let activities = res.filter(a => a.status === TASK_TEMPLATE_STATUS.publish);
        if(this.initValues){
          this.initValues ? this.controls.activity.setValue(this.initValues) : null;
          const activity = res.find(a => a.templateID === this.initValues || this.form.get('activityType')?.value);
          this.form.get('activityType').setValue(activity?.taskType, { emitEvent: false });

          if(activity?.taskType === TASK_TEMPLATE_ENUM.assessment){
            activities = activities.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.assessment);
          } else { // activity?.taskType === TASK_TEMPLATE_ENUM.meeting
            activities = activities.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.meeting);
          }
        } else {
          if(activityType === TASK_TEMPLATE_ENUM.assessment){
            activities = activities.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.assessment);
          } else { // activityType === TASK_TEMPLATE_ENUM.meeting
            activities = activities.filter((a) => a.taskType === TASK_TEMPLATE_ENUM.meeting);
          }
          this.controls.activity.setValue(activities[0]?.templateID, { emitEvent: false });
        };
        this.options = activities.map((a) => ({
          label: a?.title,
          value: a?.templateID,
        }));
      });
  }
}
